import clsx from "clsx";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import ResetPasswordForm from "ui/auth/containers/ResetPasswordForm/ResetPasswordForm";
import StatefulTabs from "ui/common/components/navigation/StatefulTabs/StatefulTabs";
import useTranslate from "ui/locale/hooks/useTranslate";
import useGoBack from "ui/router/hooks/useGoBack";
import AuthNavigationCard from "../../components/layout/AuthNavigationCard/AuthNavigationCard";
import { RecoverPasswordTabs, RECOVER_PASSWORD_TABS_TITLES } from "./RecoverPasswordPage.types";
import { RECOVER_PASSWORD_TABS } from "./RecoverPasswordTabs";

function RecoverPasswordPage() {
    const translate = useTranslate();
    const { goBack, canGoBack } = useGoBack();
    const [index, setIndex] = useState<RecoverPasswordTabs>(0);

    function handleBack() {
        if (canGoBack) goBack();
    }

    const left = index !== RecoverPasswordTabs.SUCCESS ? "back" : undefined;

    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    return (
        <AuthNavigationCard
            className={clsx("recover-password-page")}
            header={{ title: translate(RECOVER_PASSWORD_TABS_TITLES[index]), left, onLeftClick: handleBack }}
        >
            {token ? (
                <ResetPasswordForm token={token} />
            ) : (
                <StatefulTabs tabs={RECOVER_PASSWORD_TABS} onIndexChange={setIndex} index={index} defaultState={{}} />
            )}
        </AuthNavigationCard>
    );
}

export default RecoverPasswordPage;
